import React from "react";
import Button from "@mui/material/Button";

const UIButton = React.forwardRef(function UIButton(
  { children, variant = "contained", color = "primary", ...props },
  ref
) {
  return (
    <Button ref={ref} variant={variant} color={color} {...props}>
      {children}
    </Button>
  );
});

export default UIButton;
